












import Vue from "vue";
import PDF from "@/views/dashboard/PDF.vue";
export default Vue.extend({
  components: {
    PDF
  },
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
});
